import React from "react";
import Spinner from "../../../../utils/loader/Spinner";
import {useForm} from "react-hook-form";
import {useCustomerContext} from "../../../../customer/CustomerContextProvider/CustomerContextProvider";
import {emailRegExp} from "../../../../lib/ModalWindow/ForgotPasswordModal";
import {CustomerFactory} from "@connox/typescript-library";
import {getShopId} from "../../../../lib/getShopId";
import {useTranslation} from "react-i18next";
import styles from "../BrandOfTheMonthModal.module.scss";

type FormState = {
  email: string;
};

const NewsletterForm: React.FC<{onSuccess: () => void}> = ({onSuccess}) => {
  const {customer} = useCustomerContext();
  const {t} = useTranslation(["checkout", "customerAccount"]);
  const {
    formState: {errors, isSubmitting},
    register,
    handleSubmit,
  } = useForm<FormState>({mode: "onSubmit", defaultValues: {email: customer.email ?? ""}});

  const onSubmit = (data: FormState) => {
    const {email} = data;

    if (Object.keys(errors).length !== 0) {
      return;
    }

    return CustomerFactory.createOrUpdateCustomer(getShopId(), {email, newsletterFlag: true}).then(() => {
      onSuccess();
    });
  };

  return (
    <form className={styles.bomForm} noValidate onSubmit={handleSubmit(onSubmit)}>
      <input
        type="email"
        placeholder={t("Ihre E-Mail-Adresse")}
        className={errors.email ? styles.invalid : ""}
        {...register("email", {
          required: t<string>("Bitte ausfüllen"),
          pattern: {value: emailRegExp, message: t<string>("Bitte geben Sie eine gültige E-Mail-Adresse an")},
        })}
      />
      {errors.email && <span className={styles.errorMessageInput}>{errors.email.message}</span>}
      <button type="submit"> {isSubmitting ? <Spinner /> : <>{t("Jetzt abonnieren")}</>}</button>
    </form>
  );
};

export default NewsletterForm;
